/**
 * Handle the login navigation which should redirect to the referrer page if requesting
 * Marketplace page without being logged in, an to redirect when logged out. Else direct
 * to base page for either supplier or contract managers.
 *
 * @param router
 * @param user
 * @param referrer
 */
export const handleLoginNavigation = (router, user, referrer) => {
    if(referrer !== undefined && referrer !== '/') {
        router.push(referrer);
    } else {
        if(user.contractManager) {
            router.push('dashboard/allocation');
        } else {
            router.push('dashboard');
        }
    }
};

/**
 * Get the path to site or accommodation in Twenty.
 *
 * @param subPart
 * @param id
 * @returns {string}
 */
export const getContractItemTwentyPath = (subPart, id) => {
    const type = subPart === 'siteInfo' ? 'sites' : 'accommodations';
    return process.env.BACKEND_API + '/production/products/' + type + '/' + id +'/edit';
};

/**
 *
 * Get the path to create a new site or accommodation in Twenty.
 *
 * @param subPath
 * @returns {string}
 */
export const getContractItemCreatePath = (subPath) => {
    const type = subPath === 'siteInfo' ? 'sites' : 'accommodations';
    return process.env.BACKEND_API + '/production/products/' + type + '/products';
};



// WEBPACK FOOTER //
// ./src/services/NavigationService.js